<template>
    <div class="aba-cliente select-modal">
        <container-loader
            v-if="isLoading && !$store.getters.isLoading"
        />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                >
                    <search-bar
                        class="search-bar"
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-desconto-qtde-produto"
                    />
                </div>

                <div
                    class="column"
                    :class="[permissao.create&&!integracao ? (!integracaoDesconto ? 'is-2' : 'is-3') : 'is-4']"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="44"
                    />
                </div>

                <!-- <div class="column is-3" v-if="permissao.create&&!integracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVinculo"
                    >
                        {{ $t("vincular-desconto-qtde") }}
                    </button>
                </div> -->

                <div class="column is-3" v-if="permissao.create&&!integracaoDesconto">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="openModal(0)"
                    >
                        {{ $t("adicionar-desconto-qtde") }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="produtoqtdepreco"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update&&!integracaoDesconto"
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-danger'
                                        : 'is-success'"
                                :icon-right="
                                    props.row['situacao'] == 1
                                        ? 'delete'
                                        : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(
                                    props.row['situacao'] == 1
                                        ? 'desativar'
                                        : 'reativar'
                                )"
                            />
                        </div>

                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-success'
                                        : 'is-danger'
                                "
                                size="is-medium"
                            >
                                {{
                                    $t(
                                        props.row["situacao"] == 1
                                            ? "ativo"
                                            : "inativo"
                                    )
                                }}
                            </b-tag>
                        </div>

                        <div v-else-if="f.key == 'tabelapreco'">
                            <span class="tag is-info status-tag" :style=" props.row.cor ? `background-color: ${props.row.cor}` : ''">
                                {{ props.row[f.key] }}
                            </span>
                        </div>

                        <div v-else-if="f.key == 'diferenca' || f.key == 'desc-max'">
                            {{ props.row[f.key] | decimal(2) }} %
                        </div>

                        <div v-else-if="f.key == 'inicio' || f.key == 'fim'" class="nobreak">
                            {{ props.row[f.key] | decimal(3, false, 0) }}
                        </div>

                        <div v-else-if="f.key == 'cliente' || f.key == 'empresa'">
                            <a v-if="permissao.update && !integracaoDesconto"
                                @click="openModal(props.row)">
                                {{ props.row[f.key]}}
                            </a>
                        </div>

                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                        
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE CADASTRO DE DESCONTO POR QUANTIDADE -->
            <b-modal :active.sync="showModalCadastroDesconto">
                <div>
                    <DescontoQuantidadeModal
                        :descontoSelected = descontoQtdeSelecionado
                        @fecharModal="closeModalCadastro"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES E MODAIS
import ProdutoQtdePrecoService from "@/services/vendas/cliente/abas/ProdutoQtdePrecoService";
import DescontoQuantidadeModal from "@/components/vendas/produto/modal/politica-comercial/DescontoQuantidadeModal.vue";
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";

// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
        DescontoQuantidadeModal,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "ASSPRODUTOQTDEPRECO"
                ),
            integracaoDesconto:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "PRODUTOQTDEPRECO"
                ),
            produtoqtdepreco: [],
            fields: [
                { key: "cliente", width: null, sortable: true, sortFn: null },
                {
                    key: "tabelapreco",
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: "empresa", width: null, sortable: true, sortFn: null },
                { key: "inicio", width: 80, sortable: false, sortFn: null },
                { key: "fim", width: 80, sortable: false, sortFn: null },
                {
                    key: "diferenca",
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                { key: 'desc-max', width: null, sortable: false, sortFn: null },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            service: new ProdutoQtdePrecoService(this.$http, this.$router),
            serviceProduto: new VenProdutoService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            //Filtro de busca por Situação
            situacaoSelected: { id: 4, label: "todos" }, //filtro de situação padrão ao se abrir a tela
            situacaoSelect: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],

            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",

            //Ordenação de elementos na tabela
            colunaOrdenacao: "empresa", //coluna padrão para a ordenação de elementos
            order: "asc",

            isSaving: false,
            linhaParaUpdate: null, //recebe a linha que sofrerá o update
            showModalCadastroDesconto: false,
            descontoQtdeSelecionado: {},
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-politica-comercial-desconto-qtde"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "produto" },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        openModal(selected) {
            if (selected != 0) {
                this.descontoQtdeSelecionado = {};
                this.descontoQtdeSelecionado = this.produtoqtdepreco.filter((e) => {
                    return (
                        e.idprodutoqtdepreco == selected.idprodutoqtdepreco
                    );
                })[0];

                this.showModalCadastro();
            } else {
                this.descontoQtdeSelecionado = { idprodutoqtdepreco: 0 };
                this.showModalCadastro();
            }
        },
        generateId(numberId) {
            return this.$route.name + "-desconto-qtde-" + numberId;
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.serviceProduto
                .loadDescontos(
                    this.colunaOrdenacao,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.$route.params.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtoqtdepreco = value;
                    this.isEmpty = this.produtoqtdepreco.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.isLoading = false;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar descontos por quantidade.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idprodutoqtdeprecoerp: m.idprodutoqtdeprecoerp,
                    idprodutoqtdepreco: m.idprodutoqtdepreco,
                    cliente: m.cliente.nome ? m.cliente.nome : this.$t("todos"),
                    idcliente: m.cliente.idcliente,
                    tabelapreco: m.tabpreco.descricao,
                    idtabpreco: m.tabpreco.idtabpreco,
                    cor: m.tabpreco.cor,
                    empresa: m.empresa.nome,
                    idempresa: m.empresa.idempresa,
                    inicio: m.qtdeinicio,
                    fim: m.qtdefim,
                    diferenca: m.diferenca,
                    "desc-max": m.descmaximo,
                    situacao: m.situacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.colunaOrdenacao = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];

            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.linhaParaUpdate = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row["cliente"] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.linhaParaUpdate = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.linhaParaUpdate.situacao == 1
                    ? "msg-erro-ao-desativar-desconto-qtde"
                    : "msg-erro-ao-reativar-desconto-qtde";

            let tempProdutoQtdePreco = {
                idprodutoqtdepreco: this.linhaParaUpdate.idprodutoqtdepreco,
                situacao: this.linhaParaUpdate.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempProdutoQtdePreco)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-desconto-qtde"
                                : "msg-sucesso-ao-desativar-desconto-qtde";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    if(e.status === 409) {
                        this.$root.showMessage("warn", e.body.message);
                    } else {
                        console.error("Erro ao atualizar status.", e);
                        this.$root.showMessage("error", tempFailure);
                    }

                    this.isLoading = false;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.linhaParaUpdate = null;
                });
        },
        showModalCadastro() {
            this.showModalCadastroDesconto = !this.showModalCadastroDesconto;
        },
        closeModalCadastro() {
            this.showModalCadastroDesconto = false;
            this.carregarDados();
        },
    },
};
</script>

<style>
    .nobreak{
        word-break: initial;
    }
</style>

<style lang="scss" scoped>
.search-bar {
    height: 44px;
}

.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        min-height: 44px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>